import * as filters from '@/filters'
import 'driver.js/dist/driver.css'
import _ from 'lodash'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import "./assets/css/base.css"
import en from './locales/en.json'
import router from './router'
import store from './store'
import storage from './utils/localStorage.js'
Vue.prototype.$storage = storage;
Vue.prototype.$_ = _;


import Chat from './components/Chat.vue'
Vue.component('Chat', Chat)

// 引入masonry-瀑布流组件库
import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry);

import CustomeMasonry from './components/CustomeMasonry.js'
Vue.component('CustomeMasonry', CustomeMasonry);

import iView from 'iview'
import locale from 'iview/dist/locale/en-US'
import 'iview/dist/styles/iview.css'

Vue.use(iView, { locale });

import { dateFilter } from '@/filters/date'

Vue.filter('date',dateFilter.default)
Vue.filter('year', dateFilter.year)
Vue.filter('month', dateFilter.month)
Vue.filter('day', dateFilter.day)
Vue.filter('yearMonth', dateFilter.yearMonth)
Vue.filter('monthDay', dateFilter.monthDay)
Vue.filter('enDate',dateFilter.enDate)
Vue.filter('enDateFull',dateFilter.enDateWithOrdinal);
Vue.filter('enDateNoTime',dateFilter.enDateNoTime);

import { numberFormat, plainText, sex_filter2, diff_filter } from '@/filters/index.js'
Vue.filter('plainText', plainText);
Vue.filter('numberFormat',numberFormat);
Vue.filter('sex_filter2',sex_filter2);
Vue.filter('diff_filter',diff_filter);

import GlobalLoading from '@/components/Loading.vue'

// 创建全局 loading 实例
const GlobalLoadingConstructor = Vue.extend(GlobalLoading)
const globalLoadingInstance = new GlobalLoadingConstructor({
  el: document.createElement('div')
})

document.body.appendChild(globalLoadingInstance.$el)

// 挂载全局方法
Vue.prototype.$globalLoading = {
  show(message = '加载中...', showProgress = false) {
    globalLoadingInstance.show({ message, showProgress });
  },
  hide() {
    globalLoadingInstance.hide();
  },
  updateProgress(percent) {
    globalLoadingInstance.updateProgress(percent);
  }
}

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueLazyload from "vue-lazyload"
Vue.use(Viewer);

const style = document.createElement('style')
style.type = 'text/css'
style.innerHTML = '.viewer-container { z-index: 99999 !important; }'
document.head.appendChild(style)

Viewer.setDefaults({
	Options: {
		"inline": true,
		"button": true,
		"navbar": true,
		"title": true,
		"toolbar": true,
		"tooltip": true,
		"movable": true,
		"zoomable": true,
		"rotatable": true,
		"scalable": true,
		"transition": true,
		"fullscreen": true,
		"keyboard": true,
		"url": "data-source"
	}
});

// Vue.use(VueLazyload)
const loadimage = require('@/assets/images/loading.png')
const errimage = require('@/assets/images/img-err.png')
Vue.use(VueLazyload, {
	loading: loadimage,
	error: errimage,
	listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove', 'mousemove']
})
Object.keys(filters).forEach((key) => {

	Vue.filter(key, filters[key])
})

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
Vue.prototype.$layer = layer(Vue)

import CustomModal from './components/modal.js'
Vue.prototype.$DModal = CustomModal;
Vue.use(VueI18n);


const i18n = new VueI18n({
	locale: 'en', // 设置默认语言环境
	fallbackLocale: 'en', // 设置备选语言环境，当当前语言环境缺失时使用
	messages:{
		en
	}, // 设置语言环境信息
});

Vue.config.productionTip = false
new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
